import React from 'react';
import async from 'async';
import { useNavigate } from 'react-router-dom';
import toastr from 'toastr';
import Slider from 'react-rangeslider';
import PropTypes from 'prop-types';

import 'react-rangeslider/lib/index.css';

import Database from '../../Logic/Database';
import ServiceRating from '../../Logic/ServiceRating';
import ComplaintItem from '../Complaints/ComplaintItem/ComplaintItem';
import ClaimStatus from '../common/ClaimStatus/ClaimStatus';

import './RateUs.css';

class RateUsClass extends React.Component {
  constructor(props) {
    super(props);

    this.fetchRating = this.fetchRating.bind(this);
    this.saveRating = this.saveRating.bind(this);
    this.handleSliderChange = this.handleSliderChange.bind(this);
    this.handleTextChange = this.handleTextChange.bind(this);
    this.rateOne = this.rateOne.bind(this);

    this.state = {
      question1: 10,
      question2: 10,
      question3: '',
    };
  }

  componentDidMount() {
    this.fetchRating();
  }

  handleSliderChange(question, value) {
    this.setState({
      [question]: value,
    });
  }

  handleTextChange(event) {
    this.setState({
      question3: event.target.value,
    });
  }

  handleMessageClick = () => {
    this.props.navigate('/sendmessage');
  };

  handleCallAgentClick = () => {
    this.props.navigate('/callagent');
  };

  fetchRating() {
    async.waterfall([
      ServiceRating.FetchServiceRating,
      Database.WriteServiceRating,
      Database.FetchServiceRating,
    ], (error, serviceRating) => {
      if (error) {
        toastr.error(`Something went wrong and we were unable to fetch the service rating. Error: ${error.message}`, 'Oops');
      } else {
        this.setState({
          question1: serviceRating.RatingQuestion1,
          question2: serviceRating.RatingQuestion2,
          question3: serviceRating.Comments,
        });
      }
    });
  }

  rateOne() {
    if (this.state.question1 < 3 || this.state.question2 < 3) {
      return (
        <div className="row grey-cell">
          <div className="col-xs-12">
            <p>
              OH No! Please help us understand what happened.
              Send us a Message or Call your agent directly.
            </p>
          </div>
          <div className="col-xs-12">
            <div className="row" id="complaints-buttons">
              <ComplaintItem
                buttonText="Message our complaints team"
                iconClass="message-complaints"
                onClick={this.handleMessageClick}
                offsetClass="col-xs-offset-2"
              />
              <ComplaintItem
                buttonText="Call your agent"
                iconClass="call-agent"
                onClick={this.handleCallAgentClick}
              />
            </div>
          </div>
        </div>
      );
    }
    return null;
  }

  saveRating() {
    async.waterfall([
      (callback) => {
        Database.SetRating({
          RatingQuestion1: this.state.question1,
          RatingQuestion2: this.state.question2,
          Comments: this.state.question3,
        }, callback);
      },
      ServiceRating.UpdateRating,
      Database.ServiceRatingSynchronised,
    ], (error) => {
      if (error) {
        toastr.error(`Something went wrong and we were unable to set the rating. Error: ${error.message}`, 'Oops');
      } else {
        toastr.success('Successfully submitted rating.', 'Thank you');
      }
    });
  }

  render() {
    return (
      <div>
        <div className="row">
          <ClaimStatus />
        </div>
        <div className="row" id="rate-us">
          <div className="col-xs-12">
            <h4 id="rate-us-header">Rate Us</h4>
            <div>
              How likely are you to recommend Autoboys to family, friends, or colleagues?
              Scale - 10 highly likely to 1 unlikely.
            </div>
            <div className="col-xs-12 slider">
              <Slider
                value={this.state.question1}
                orientation="horizontal"
                onChange={(value) => this.handleSliderChange('question1', value)}
                max={10}
              />
              <div className="value">{this.state.question1}</div>
            </div>
            <div>
              How easy was it for you to conclude your auto glass claim?
              Scale - 10 very easy to 1 very difficult.
            </div>
            <div className="col-xs-12 slider">
              <Slider
                value={this.state.question2}
                orientation="horizontal"
                onChange={(value) => this.handleSliderChange('question2', value)}
                max={10}
              />
              <div className="value">{this.state.question2}</div>
            </div>
            <div>
              Do you have any suggestions or comments that would have made the process easier?
            </div>
            <div className="col-xs-12">
              <textarea
                className="form-control"
                rows="4"
                value={this.state.question3}
                onChange={this.handleTextChange}
              />
            </div>

            <button type="button" className="btn btn-success" onClick={this.saveRating}>Submit</button>
          </div>
        </div>
        {this.rateOne()}
      </div>
    );
  }
}

RateUsClass.propTypes = {
  navigate: PropTypes.func.isRequired,
};

function RateUs(props) {
  const navigate = useNavigate();
  return <RateUsClass {...props} navigate={navigate} />;
}

export default RateUs;
